import { render } from "./PersonalSavingsComplete.vue?vue&type=template&id=738a4c91&scoped=true"
import script from "./PersonalSavingsComplete.vue?vue&type=script&lang=js"
export * from "./PersonalSavingsComplete.vue?vue&type=script&lang=js"

import "./PersonalSavingsComplete.vue?vue&type=style&index=0&id=738a4c91&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738a4c91"]])

export default __exports__